import { resolveStorefrontOrgSlug } from "./api";
import { buildStorePathFor, productPathFor, type ProductLinkRef } from "./product-path";

export type { ProductLinkRef } from "./product-path";

/**
 * Ruta interna de la tienda activa (`/s/<orgSlug>/…`). Usar SIEMPRE este
 * helper para links internos: un "/x" sin prefijo cae en el redirect legacy.
 */
export function buildStorePath(path: string): string {
  return buildStorePathFor(resolveStorefrontOrgSlug(), path);
}

/** Link al detalle de producto: prefijo de tienda + slug o, si no hay, id. */
export function productPath(product: ProductLinkRef | null | undefined): string {
  return productPathFor(resolveStorefrontOrgSlug(), product);
}
